import * as React from 'react'
import { Backdrop, CircularProgress } from '@mui/material'

/**
 * Creating context
 */
export const LoadingContext = React.createContext()

/**
 * Context provider component
 */
export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = React.useState(false)

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
      <Backdrop open={loading} sx={{ zIndex: 999 }}>
        <CircularProgress color="primary" />
      </Backdrop>
    </LoadingContext.Provider>
  )
}
